// @styles
require('./aggregatorResume.scss');

// vendors
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

// components
import { OKButton } from 'components/commons/OKButton/OKButton';
import { LoadingSection } from 'commonsComponents/loadingSection';
import AggregatorResumeNoEntities from 'components/aggregator/aggregatorResume/aggregatorResumeNoEntities';
import AggregatorTinkResumeNoEntities from 'components/aggregator/tink/aggregatorTinkResumeNoEntities/aggregatorTinkResumeNoEntities';
import AggregatorResumeEntities from 'components/aggregator/aggregatorResume/aggregatorResumeEntities';
import { AggregatorStatus } from 'components/aggregator/aggregatorStatus/aggregatorStatus';
import { AggregatorTinkStatus } from 'components/aggregator/tink/aggregatorTinkStatus/aggregatorTinkStatus';

// utilities
import {
  recordLink,
  PROC_RESTART,
  PROC_REVIEW,
  PROC_START,
  EVENT_ADD_MORE_ENTITY,
  PROC_ADD_ENTITY,
  PROC_ADD_ENTITY_ERROR,
  EVENT_ERROR_ENTITY,
  TINK_PG_PAGE_NAME,
  TINK_PG_ADD_BANK_TAG,
  TINK_PG_SETTINGS_TAG,
} from 'utilities/tagging';
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { FormattedText, formatText } = require('core/i18n').i18n;

// assets
import addBlueIcon from 'routes/aggregatorTink/assets/add-blue-icon.svg';

// constants
import {
  OK,
  BAD_CREDENTIALS,
  KO,
  PENDING,
  SYNC,
  MULTIPLE_PENDING,
  PARTIAL_OK,
  BLOCKED,
  ROBOT_ERROR,
  REVIEW,
  PSD2_CONSENT_INVALID,
} from 'constants/aggregator/statuses';
import {
  UPDATED,
  AUTHENTICATION_ERROR,
  TEMPORARY_ERROR,
  UPDATING,
  AUTHENTICATING,
  AWAITING_SUPPLEMENTAL_INFORMATION,
  AWAITING_THIRD_PARTY_APP_AUTHENTICATION,
  AWAITING_MOBILE_BANKID_AUTHENTICATION,
  SESSION_EXPIRED,
} from 'constants/aggregator/tinkStatuses.constants';

const ERROR_STATUSES = [
  // Tink
  SESSION_EXPIRED,
  TEMPORARY_ERROR,
  AUTHENTICATION_ERROR,
  AWAITING_SUPPLEMENTAL_INFORMATION,
  AWAITING_THIRD_PARTY_APP_AUTHENTICATION,
  AWAITING_MOBILE_BANKID_AUTHENTICATION,
  // Eurobits
  BAD_CREDENTIALS,
  KO,
  PARTIAL_OK,
  BLOCKED,
  ROBOT_ERROR,
  REVIEW,
  PSD2_CONSENT_INVALID,
];
const LOADING_STATUSES = [
  // Tink
  UPDATING,
  AUTHENTICATING,
  // Eurobits
  PENDING,
  SYNC,
];

class AggregatorResume extends React.Component {
  constructor(props) {
    super(props);
  }

  handleAddEntityClick = () => {
    const { history, isTinkAggregator } = this.props;

    if (isTinkAggregator) {
      recordLink(TINK_PG_PAGE_NAME, '', TINK_PG_ADD_BANK_TAG);
    } else {
      recordLink(PROC_ADD_ENTITY, PROC_START, EVENT_ADD_MORE_ENTITY);
    }
    history.push('/myprofile/global/entities/add');
    scrollToTop();
  };

  handleRetryClick = () => {
    recordLink(PROC_ADD_ENTITY_ERROR, PROC_RESTART);
    this.props.retryAction();
  };

  handleSettingsClick = () => {
    const { history, isTinkAggregator } = this.props;
    if (isTinkAggregator) {
      recordLink(TINK_PG_PAGE_NAME, '', TINK_PG_SETTINGS_TAG);
    }
    history.push('/myprofile/global/entities/manage');
    scrollToTop();
  };

  handleReviewClick = () => {
    recordLink(PROC_ADD_ENTITY, PROC_REVIEW, EVENT_ERROR_ENTITY);
    this.props.history.push('/myprofile/global/entities/manage');
    scrollToTop();
  };

  renderHeader = (renderButton = true) => {
    const getHeaderClassName = (className) => {
      const rootClass = !className
        ? 'aggregator-resume-section__header'
        : `aggregator-resume-section__header${className}`;

      return classNames(rootClass, {
        tink: this.props.isTinkAggregator,
      });
    };

    return (
      <div className={getHeaderClassName()}>
        <h3 className={getHeaderClassName('-title')}>
          <FormattedText value="aggregatorResume-title" />
        </h3>
        {renderButton && (
          <div className={getHeaderClassName('__settings')}>
            <OKButton modifier="link-ghost" onClick={this.handleSettingsClick}>
              <i className={getHeaderClassName('__settings__icon icon-preferencias')} />
            </OKButton>
            <span className={getHeaderClassName('__settings-text')}>
              {formatText('aggregatorResume-settingsButton')}
            </span>
          </div>
        )}
      </div>
    );
  };

  renderSubheader = error => {
    const { immAggregatorData, isTinkAggregator } = this.props;
    const errorBanks = immAggregatorData.getIn(['error']);

    const containerButtonClass = classNames('aggregator-resume-section__content__header__add', {
      'tink': isTinkAggregator,
      'col-xs-6': errorBanks,
      'col-xs-4': !errorBanks,
    });

    return !error ? (
      <div className="aggregator-resume-section__content__header row">
        <div className={containerButtonClass}>
          <OKButton
            modifier="ghost"
            onClick={this.handleAddEntityClick}
            leftIcon={!isTinkAggregator && 'icon-agregar'}
          >
            {isTinkAggregator && (
              <img
                className="aggregator-resume-section__content__header__addIcon"
                src={addBlueIcon}
              />
            )}
            {formatText('aggregatorResume-addEntityButton')}
          </OKButton>
        </div>
      </div>
    ) : null;
  };

  renderBanksAccordionContent(loading, error, hasSomeErrors) {
    const { immAggregatorData, flagBasedFeatures, isTinkAggregator } = this.props;

    if (error) return null;
    if (loading) return null;

    return (
      <AggregatorResumeEntities
        flagBasedFeatures={flagBasedFeatures}
        immAggregatorData={immAggregatorData}
        isTinkAggregator={isTinkAggregator}
        hasSomeErrorStatuses={hasSomeErrors}
      />
    );
  }

  renderSecondPhaseContent() {
    const { immAggregatorData, getSecondFactorAuth } = this.props;
    let pendingBanks = [];
    let noPendingBanks = [];
    let secondPhaseBanks = [];
    const banks = immAggregatorData.getIn(['data', 'banks']);

    banks.toMap().mapKeys((key, value) => {
      secondPhaseBanks.push({
        name: value.get('name'),
        code: value.get('code'),
        logo: value.get('imageUrl'),
        userBankId: key,
        status: value.get('status'),
        psd2Status: value.get('psd2Status'),
      });
    });

    pendingBanks = secondPhaseBanks.filter(bank => bank.status === PENDING);
    noPendingBanks =
      pendingBanks.length > 2
        ? secondPhaseBanks.filter(bank => bank.status !== PENDING)
        : secondPhaseBanks;

    return (
      <Fragment>
        {pendingBanks.length > 2 && (
          <div key="generic" className="aggregator-resume-section__content__second-key-container">
            <AggregatorStatus bankStatus={MULTIPLE_PENDING} />
          </div>
        )}
        {noPendingBanks.map((bank, index) => {
          return (
            <Fragment>
              {bank.status && (
                <div
                  key={index}
                  className="aggregator-resume-section__content__second-key-container"
                >
                  <AggregatorStatus
                    bankName={bank.name}
                    bankCode={bank.code}
                    bankLogo={bank.logo}
                    userBankId={bank.userBankId}
                    getSecondFactorAuth={getSecondFactorAuth}
                    bankStatus={bank.status}
                  />
                </div>
              )}
              {bank.psd2Status && (
                <div
                  key={index}
                  className="aggregator-resume-section__content__second-key-container"
                >
                  <AggregatorStatus
                    bankName={bank.name}
                    bankCode={bank.code}
                    bankLogo={bank.logo}
                    userBankId={bank.userBankId}
                    getSecondFactorAuth={getSecondFactorAuth}
                    bankStatus={bank.psd2Status}
                  />
                </div>
              )}
            </Fragment>
          );
        })}
      </Fragment>
    );
  }

  renderAggTinkStatus(
    hasMultiplePendingBanks,
    pendingBanks,
    hasOkBanks,
    hasPendingBanks,
    getSecondFactorAuth,
    hasNoPendingBanks,
    noPendingBanks,
    banksWithError,
    hasErrorBank
  ) {
    const getShowBank = status => status && ![OK, UPDATED].includes(status);

    return (
      <Fragment>
        {hasMultiplePendingBanks && (
          <div key="generic" className="aggregator-resume-section__content__second-key-container">
            <AggregatorTinkStatus
              bankStatus={MULTIPLE_PENDING}
              bankName={pendingBanks.length}
              isLeftAlign={hasOkBanks}
            />
          </div>
        )}
        {hasPendingBanks &&
          pendingBanks.map(bank => {
            return (
              <Fragment>
                {getShowBank(bank.tinkPsd2Status || bank.psd2Status) && (
                  <AggregatorTinkStatus
                    bankName={bank.name}
                    bankCode={bank.code}
                    bankLogo={bank.logo}
                    userBankId={bank.userBankId}
                    getSecondFactorAuth={getSecondFactorAuth}
                    bankStatus={bank.tinkPsd2Status || bank.psd2Status}
                    isLeftAlign={hasOkBanks}
                    bankTinkCredentials={bank.tinkPsd2CredentialsId}
                  />
                )}
                {getShowBank(bank.tinkStatus || bank.status) && (
                  <AggregatorTinkStatus
                    bankName={bank.name}
                    bankCode={bank.code}
                    bankLogo={bank.logo}
                    userBankId={bank.userBankId}
                    getSecondFactorAuth={getSecondFactorAuth}
                    bankStatus={bank.tinkStatus || bank.status}
                    isLeftAlign={hasOkBanks}
                    bankTinkCredentials={bank.tinkCredentialId}
                  />
                )}
              </Fragment>
            );
          })}
        {hasNoPendingBanks &&
          noPendingBanks.map(bank => {
            return (
              <Fragment>
                {getShowBank(bank.tinkPsd2Status || bank.psd2Status) && (
                  <AggregatorTinkStatus
                    bankName={bank.name}
                    bankCode={bank.code}
                    bankLogo={bank.logo}
                    userBankId={bank.userBankId}
                    getSecondFactorAuth={getSecondFactorAuth}
                    bankStatus={bank.tinkPsd2Status || bank.psd2Status}
                    isLeftAlign={hasOkBanks}
                    bankTinkCredentials={bank.tinkPsd2CredentialsId}
                  />
                )}
                {getShowBank(bank.tinkStatus || bank.status) && (
                  <AggregatorTinkStatus
                    bankName={bank.name}
                    bankCode={bank.code}
                    bankLogo={bank.logo}
                    userBankId={bank.userBankId}
                    getSecondFactorAuth={getSecondFactorAuth}
                    bankStatus={bank.tinkStatus || bank.status}
                    isLeftAlign={hasOkBanks}
                    bankTinkCredentials={bank.tinkCredentialId}
                  />
                )}
              </Fragment>
            );
          })}
        {hasErrorBank &&
          banksWithError.map((bank, index) => {
            return (
              <Fragment>
                {getShowBank(bank.tinkPsd2Status || bank.psd2Status) && (
                  <div
                    key={index}
                    className="aggregator-resume-section__content__second-key-container"
                  >
                    <AggregatorTinkStatus
                      bankName={bank.name}
                      bankCode={bank.code}
                      bankLogo={bank.logo}
                      userBankId={bank.userBankId}
                      getSecondFactorAuth={getSecondFactorAuth}
                      bankStatus={bank.tinkPsd2Status || bank.psd2Status}
                      isLeftAlign={hasOkBanks}
                      bankTinkCredentials={bank.tinkPsd2CredentialsId}
                    />
                  </div>
                )}
                {getShowBank(bank.tinkStatus || bank.status) && (
                  <div
                    key={index}
                    className="aggregator-resume-section__content__second-key-container"
                  >
                    <AggregatorTinkStatus
                      bankName={bank.name}
                      bankCode={bank.code}
                      bankLogo={bank.logo}
                      userBankId={bank.userBankId}
                      getSecondFactorAuth={getSecondFactorAuth}
                      bankStatus={bank.tinkStatus || bank.status}
                      isLeftAlign={hasOkBanks}
                      bankTinkCredentials={bank.tinkCredentialId}
                    />
                  </div>
                )}
              </Fragment>
            );
          })}
      </Fragment>
    );
  }

  renderTinkBankStatusContent(loading, error) {
    const { immAggregatorData, getSecondFactorAuth } = this.props;
    let pendingBanks = [];
    let noPendingBanks = [];
    let mappedBanks = [];
    const banks = immAggregatorData.getIn(['data', 'banks']);

    banks.toMap().mapKeys((key, value) => {
      mappedBanks.push({
        name: value.get('name'),
        code: value.get('code'),
        logo: value.get('imageUrl'),
        userBankId: key,
        tinkStatus: value.get('tinkStatus'),
        tinkPsd2Status: value.get('tinkPsd2Status'),
        status: value.get('status'),
        psd2Status: value.get('psd2Status'),
        tinkCredentialId: value.get('tinkCredentialId'),
        tinkPsd2CredentialsId: value.get('tinkPsd2CredentialsId'),
        psd2Credentials: value.get('psd2Credentials'),
        scrapingCredentials: value.get('scrapingCredentials'),
      });
    });

    const pendingBanksTink = mappedBanks.filter(bank =>
      LOADING_STATUSES.includes(
        bank.tinkStatus || bank.status || bank.tinkPsd2Status || bank.psd2Status
      )
    );
    const noPendingBanksTink = mappedBanks.filter(
      bank =>
        !LOADING_STATUSES.includes(
          bank.tinkStatus || bank.status || bank.tinkPsd2Status || bank.psd2Status
        )
    );

    const pendingBanksEurobits = mappedBanks.filter(bank => bank.status === PENDING);
    const noPendingBanksEurobits =
      pendingBanksEurobits.length > 2
        ? mappedBanks.filter(bank => bank.status !== PENDING || bank.status !== OK)
        : mappedBanks;

    const banksWithError = mappedBanks.filter(bank =>
      ERROR_STATUSES.includes(
        bank.tinkPsd2Status || bank.tinkStatus || bank.status || bank.psd2Status
      )
    );

    pendingBanks = pendingBanksTink || pendingBanksEurobits;
    noPendingBanks = banksWithError.length === 0 && (noPendingBanksTink || noPendingBanksEurobits);

    const hasMultiplePendingBanks = pendingBanks.length >= 2;
    const hasPendingBanks = !hasMultiplePendingBanks && pendingBanks.length > 0;
    const hasNoPendingBanks = !hasMultiplePendingBanks && noPendingBanks.length > 0;

    const hasErrorBank = banksWithError.length > 0;

    const hasOkBanks = !(error || loading);

    return this.renderAggTinkStatus(
      hasMultiplePendingBanks,
      pendingBanks,
      hasOkBanks,
      hasPendingBanks,
      getSecondFactorAuth,
      hasNoPendingBanks,
      noPendingBanks,
      banksWithError,
      hasErrorBank
    );
  }

  render() {
    const { immAggregatorData, isTinkAggregator } = this.props;

    const errorBanks = immAggregatorData.getIn(['error']);
    const isFetching = immAggregatorData.getIn(['isFetching']);
    const banks = immAggregatorData.getIn(['data', 'banks']);

    if (!errorBanks && !isFetching && !banks.size) {
      return isTinkAggregator ? (
        <AggregatorTinkResumeNoEntities />
      ) : (
        <AggregatorResumeNoEntities immAggregatorData={immAggregatorData} />
      );
    }
    if (!errorBanks && isFetching && !banks.size) return <LoadingSection />;

    const renderErrorEurobits =
      errorBanks || (!isFetching && banks.size && banks.every(b => b.get('status') == KO));
    const renderErrorTink =
      errorBanks ||
      (!isFetching &&
        banks.size &&
        banks.every(b => ERROR_STATUSES.includes(b.get('tinkStatus') || b.get('status'))));

    const hasSomeErrors =
      banks.size &&
      banks.every(b =>
        ERROR_STATUSES.includes(
          (b.get('tinkStatus') && b.get('tinkPsd2Status')) ||
            (b.get('status') && b.get('psd2Status'))
        )
      );

    const renderLoadingEurobits =
      (isFetching && banks.size && banks.every(b => b.get('status') == KO)) ||
      banks.every(b => b.get('status') == PENDING);
    const renderLoadingTink =
      isFetching &&
      banks.size &&
      banks.every(b => LOADING_STATUSES.includes(b.get('tinkStatus') || b.get('status')));

    const hasBanks = banks.size > 0;
    const showSettingsButtonTink = !renderLoadingTink && hasBanks;
    const showSettingsButtonEurobits = !renderLoadingEurobits && hasBanks;

    const contentClassnames = classNames('aggregator-resume-section__content', {
      tink: isTinkAggregator,
      noBanks: !hasBanks,
      loading: renderLoadingTink,
    });

    return (
      <div id="pg-other-banks" className="aggregator-resume-section">
        {isTinkAggregator
          ? this.renderHeader(showSettingsButtonTink)
          : this.renderHeader(showSettingsButtonEurobits)}
        <div className={contentClassnames}>
          {this.renderSubheader()}
          {isTinkAggregator
            ? this.renderTinkBankStatusContent(renderLoadingTink, renderErrorTink)
            : this.renderSecondPhaseContent()}
          {isTinkAggregator
            ? this.renderBanksAccordionContent(renderLoadingTink, renderErrorTink, hasSomeErrors)
            : this.renderBanksAccordionContent(renderLoadingEurobits, renderErrorEurobits)}
        </div>
      </div>
    );
  }
}

AggregatorResume.propTypes = {
  immAggregatorData: PropTypes.object,
  retryAction: PropTypes.func,
  flagBasedFeatures: PropTypes.object,
  getSecondFactorAuth: PropTypes.func,
  history: PropTypes.object.isRequired,
  isTinkAggregator: PropTypes.bool,
};

module.exports = withRouter(AggregatorResume);
